import { Menu, message } from 'antd'
import { createSideFormComponent } from 'factories/SideForm'
import { Emitter } from 'helpers/events'
import { getUserPermission } from 'helpers/auth'
import { t } from 'helpers/i18n'
import Search from 'containers/Products/Select'

export default createSideFormComponent({
  getStorageKey: (self) => 'orders.formView.sideForm',
  searchLanguageKey: 'searchProducts',
  addItemLanguageKey: 'addToOrder',
  addItemsLanguageKey: 'addToOrder',
  addItemSuccessLanguageKey: 'addToOrderSuccess',
  submitButtonLanguageKey: 'add',
  tagSettingsEnabledSuffix: 'Purch',
  dropDownButtonMenuItems: (self) => {
    if (getUserPermission('FavoritesOnly') === 'Yes') {
      return []
    }

    const allowPunchout =
      !self.props.useInventoryBarcode &&
      ['New'].includes(self.props.parentRecord.status) &&
      getUserPermission('AllowPunchout') === 'Yes'

    return [
      ...(allowPunchout ? [<Menu.Item key="punchout">{t('punchout')}</Menu.Item>] : []),
      ...(getUserPermission('AddNonStockItems') !== 'No'
        ? [<Menu.Item key="addNonStock">{t('addNonStock')}</Menu.Item>]
        : []),
      ...(!self.props.useInventoryBarcode
        ? [
            <Menu.Item key="addFromList">{t('addFromList')}</Menu.Item>,
            <Menu.Item key="addFromFile">{t('addFromFile')}</Menu.Item>,
          ]
        : []),
    ]
  },
  dropdownButtonMenuClickHandler: (self) => (e) => {
    if (e.key === 'addNonStock') {
      Emitter.emit('orders.orderItems.createButtonClick', {
        ...self.state,
        nonStock: true,
      })
    }

    if (e.key === 'punchout') {
      if (self.props.parentRecord?.id && !self.props.parentHasUnsavedChanges) {
        self.handlePunchoutClick?.()
      } else {
        message.error(t('saveChangesFirst'))
      }
    }

    if (e.key === 'addFromList') {
      self.handleAddFromListClick?.()
    }

    if (e.key === 'addFromFile') {
      self.handleAddFromFileClick?.()
    }
  },
})(Search)
